(function($) {
    'use strict';

    jQuery(document).ready(function($) {
        $(document).on('click', '.show-more', function(e) {
            e.preventDefault();
            
            if($(this).hasClass('show-more-slide')) {
                $(this).parent().find('.show-more-wrapper').slideDown();
            }
            else {
                $(this).parent().find('.show-more-item').fadeIn();
            }

            $(this).remove();
        });

        function toggleShowMoreMobile() {
            if($('.show-more-section').height() > 250) {
                $('.show-more-section .show-more-wrapper').addClass('show-more-mobile');
                $('.show-more-section .show-more-text').addClass('show-more-mobile');
            } else {
                $('.show-more-section .show-more-wrapper').removeClass('show-more-mobile');
                $('.show-more-section .show-more-text').removeClass('show-more-mobile');
            }
        }

        if($('.show-more-section').length) {
            toggleShowMoreMobile();

            $( window ).on('resize', function() {
                toggleShowMoreMobile();
            });
        }

        $(document).on('click', '.show-more-text', function(e) {
            e.preventDefault();
            $(this).parent().find('.show-more-wrapper').addClass('toggled');
            $(this).remove();
        });
    });

})(jQuery);